module.exports = __webpack_public_path__ + "img/naver_ai_labs.ba503c3a.png";